import React from 'react'
import type { SortFilter, SortOrder } from '@core/Areas/FollowMe/types'
import { useSharedBetsData } from '../../hooks/useSharedBetsData'

import { SortFeed } from '@core/Areas/FollowMe/Components/Common/SortFeed'
import { SharedBetCard } from '@core/Areas/FollowMe/Components/Common/SharedBetCard'
import { FeedContainerStyled } from '@core/Areas/FollowMe/Components/Common/FollowMe.styles'
import { PullToRefreshContainer } from '@mobi/component-library/Common/PullToRefreshContainer'
import { SkeletonLoader } from '../Common/SkeletonLoader'
import { NewFeedPostsManager } from '../Common/NewFeedPostsManager'

let sessionSortOrder: SortOrder = 'sortAsc'
let sessionSortFilder: SortFilter = 'JumpTime'

export const ExploreFeed: React.FC = () => {
  const [sortOrder, setSortOrder] = React.useState<SortOrder>(sessionSortOrder)
  const [sortFilter, setSortFilter] = React.useState<SortFilter>(sessionSortFilder)

  React.useEffect(() => {
    sessionSortOrder = sortOrder
    sessionSortFilder = sortFilter
  }, [sortFilter, sortOrder])

  const { isLoading, data, refetch, isRefetching, LoadMoreButton, firstPostSeenId } =
    useSharedBetsData({
      sortFilter,
      sortOrder,
    })

  return (
    <>
      <SortFeed
        sortFilter={sortFilter}
        sortOrder={sortOrder}
        handleSortFilterChange={setSortFilter}
        handleSortOrderChange={setSortOrder}
      />

      {isLoading || isRefetching || !data ? (
        <SkeletonLoader />
      ) : (
        <PullToRefreshContainer onRefresh={refetch}>
          <FeedContainerStyled>
            <NewFeedPostsManager
              fromPostId={firstPostSeenId}
              sortOrder={sortOrder}
              sortFilter={sortFilter}
            />

            {data.pages.map(feedPage =>
              feedPage.map(sharedBet => (
                <SharedBetCard key={sharedBet.postId} sharedBet={sharedBet} />
              ))
            )}

            <LoadMoreButton />
          </FeedContainerStyled>
        </PullToRefreshContainer>
      )}
    </>
  )
}
